module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("2")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE NEWS THAT MY MOTHER")]), _vm._v(" had cancer came in the middle of the night. I took the call and then sat on the edge of the bed with my head in my hands. Though Tesseba, my wife, did not understand why—tried to stop me in fact—I left the house at two in the morning and waited for dawn on a bench at the airport. I landed in London and rushed from Heathrow to Arnold’s home, but even as I walked in the door I realized that something more than a change in my mother’s health had taken place. She had always served as a buffer between Arnold and me—Tibor, my sister Bridget’s sturdy Bulgarian husband, once called my mother Arnold’s “human shield.” Her well-being demanded that we avoid open conflict—but it was immediately clear that those days were over. Arnold met me at the front door, a rare event, and insisted on detaining me in his study while he “prepared” me for what I was about to see. When I was finally permitted up into the bedroom I found my mother changed, newly fragile, as if in shock, almost absent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My secretary had made reservations for me and Bridget, who arrived later the same day, at a nearby hotel, but leaving my mother’s side once she had seen her condition was unthinkable for Bridget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Are you sure you want to do this, Bridgie?” I asked. “Staying here means exposure to an awful lot of Arnold.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“As sure as I am of anything,” she answered, and yet the next morning she was not so sure any more. That first night, after a long flight and hours of panic, she received a preview of what lay ahead.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("“Time to leave Mom alone now,” Arnold had said shortly after dinner, even though Bridget and my mother were involved in some discussion or other, talking about the things they always did, engrossed, as was often true, in each other.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“She’s fine,” Bridget had said. “Quite peppy, in fact.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("“Out, out,”")]), _vm._v(" Arnold had insisted as if she had not spoken, pretending to be acting with good humor but quite determined nonetheless. “My Helgie needs her sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“In a while,” Bridget had said, but then, almost inevitably, the betrayal: “Perhaps I am tired,” my mother had said. “We can talk in the morning.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e0f7c38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Chapter02.vue
// module id = 87
// module chunks = 0